var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { breakpoints } from "../_styleguide/_breakpoints";
import { colours } from "../_styleguide/_colours";
import { thousands } from "../d3-services/_helpers";
import { filterLatest, getNeededColumns } from '../d3-services/data.functions';
import { GraphControllerV2 } from './graph-v2';
var TickerBol = /** @class */ (function (_super) {
    __extends(TickerBol, _super);
    function TickerBol(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        return _this;
    }
    TickerBol.prototype.init = function () {
        var self = this;
        this.element.style.display = 'flex';
        this.element.style.flexDirection = 'row';
        this.element.style.flexWrap = 'wrap';
        this.element.style.flexDirection = 'column-reverse';
        this.element.style.justifyContent = 'space-between';
        if (window.innerWidth < breakpoints.sm) {
            this.element.style.width = '100%';
            this.element.style.margin = '1.5rem auto';
            //    this.element.style.height = '9.5rem';
        }
        else if (window.innerWidth < breakpoints.md) {
            this.element.style.flex = '0 0 30%';
            this.element.style.margin = '2rem auto 0 auto';
            this.element.style.height = '100%';
        }
        else {
            this.element.style.flexWrap = 'nowrap';
            this.element.style.flex = '0 0 25%';
            this.element.style.padding = '1rem 0';
            this.element.style.height = '100%';
        }
        var labelContainer = document.createElement('div');
        labelContainer.style.width = '100%';
        labelContainer.style.textAlign = 'center';
        labelContainer.innerText = this.mapping.parameters[0][0]['label'];
        this.element.appendChild(labelContainer);
        if (window.innerWidth < breakpoints.sm) {
            labelContainer.style.height = '2rem';
        }
        else if (window.innerWidth < breakpoints.md) {
            labelContainer.style.height = '1.5rem';
        }
        else {
            labelContainer.style.height = '2.5rem';
        }
        self.update(this.data, this.segment);
    };
    TickerBol.prototype.prepareData = function (data) {
        var neededColumns = getNeededColumns(data, this.mapping);
        return {
            "history": null,
            "latest": filterLatest(data, neededColumns),
            "slice": null
        };
    };
    TickerBol.prototype.redraw = function (data) {
        var value = (this.config.extra.decimal) ? data.latest[this.parameters.y] : Math.round(data[0][this.parameters.y]);
        var el = this.element.querySelector('.number');
        el.innerText = (value > 9999) ? thousands(value) : value;
    };
    TickerBol.prototype.draw = function (data) {
        var miniContainer = document.createElement('div');
        miniContainer.style.display = 'flex';
        miniContainer.style.flexDirection = 'column';
        miniContainer.style.alignItems = 'center';
        var div = document.createElement('div');
        div.classList.add('number_circle');
        div.style.backgroundColor = colours[this.mapping.parameters[0][0].colour][1];
        div.style.border = '1px solid ' + colours[this.mapping.parameters[0][0].colour][0];
        div.style.borderRadius = '50%';
        div.style.display = 'flex';
        div.style.position = 'relative';
        div.style.flexDirection = 'column';
        div.style.justifyContent = 'center';
        div.style.alignItems = 'center';
        div.style.width = (this.config.extra.circleRadius) ? this.config.extra.circleRadius.toString() + 'rem' : '7.5rem';
        div.style.height = (this.config.extra.circleRadius) ? this.config.extra.circleRadius.toString() + 'rem' : '7.5rem';
        var number = document.createElement('span');
        number.classList.add('number');
        number.style.fontSize = '2.25rem';
        number.style.lineHeight = "1";
        number.style.color = 'black';
        number.style.fontFamily = "Replica";
        div.appendChild(number);
        miniContainer.appendChild(div);
        this.element.insertBefore(miniContainer, this.element.childNodes[0]);
    };
    TickerBol.prototype.update = function (newData, segment) {
        var self = this;
        var data = self.prepareData(newData);
        self.draw(data);
        self.redraw(data);
        window.addEventListener("resize", function () { return self.redraw(data); }, false);
    };
    return TickerBol;
}(GraphControllerV2));
export default TickerBol;
